module.exports = __webpack_public_path__ + "static/carousel-3-8a06e7d4fb8140c30d0ceea9d5dcf268.png";